import { useEffect, useRef } from "react";

export function useDocumentTitle(title?: string, removeSuffix?: boolean) {
    const originalTitleRef = useRef<string>();

    useEffect(() => {
        if (originalTitleRef.current === undefined) {
            originalTitleRef.current = document.title;
        }

        if (title && title.length > 0) {
            document.title = removeSuffix ? title : `${title} | Ona`;
        }

        // on unmount, restore original title. This is useful when there's two instances of the hook with one of them executing after the other
        // (like in a page section or a modal), that would otherwise persist the title even after the component is unmounted
        return () => {
            if (originalTitleRef.current !== undefined) {
                document.title = originalTitleRef.current;
            }
        };
    }, [title, removeSuffix]);
}
